/* eslint no-eval: 0 */

import React from 'react';
import {_GPY} from '../../../env.js'
import TimerText from './TimerText.js'
import DataText from './DataText.js'
import AnalogClock from './AnalogClock.js';
import Animator from './Animator.js';

class Overlay extends Animator {

  constructor(props) {
    super(props);

    this.state = {
      active: false,
      data  : undefined,
      numberData: 0,
      booleanData: false,
      overlayConfig: this.props.display.state.overlays!==undefined&&this.props.display.state.overlays[this.props.overlayConf]!==undefined?this.props.display.state.overlays[this.props.overlayConf].overlay:{},
      transition : "transition-start" ,
      timerIsActive: false,
      eventListener:{},
    };
  }

  registDataListener(name,listener) {
    var l = this.state.eventListener;
    l[name] = listener;
    this.setState({"eventListener":l});
  }

  onSetTimeout(){
    console.log(this.props.stateName+" onSetTimeout");
  }

  onInit(overlayConfig){
      super.animate(false,overlayConfig);
  }


  updateOverlay() {
    this.setState({overlayConfig: this.props.display.state.overlays!==undefined&&this.props.display.state.overlays[this.props.overlayConf]!==undefined?this.props.display.state.overlays[this.props.overlayConf].overlay:{}})
  }

  onData (data,key) {
    if(typeof data === 'object') {

        var doAnim = false;
        if(data.visible === undefined) {
            this.setState({ data:data });
        } else {
          if(data.visible === true ) {
              if(this.state.active !== data.visible) {
                  doAnim=true;
               }
               this.setState({active: data.visible, data:data} , ()=>{
                      if(doAnim) super.animate(data.visible,this.state.overlayConfig);
               });
          } else {
              this.setState({active: data.visible } , ()=>{
                  super.animate(data.visible,this.state.overlayConfig);
              });
          }
      }

    } else if( typeof data === 'number' ) {
        this.setState({numberData: data});
    } else if(typeof data === 'boolean') {
        this.setState({booleanData: data});
    }
  }

  sortProperties(obj) {
    var sortable=[];
	  for(var key in obj) {
		    if(obj.hasOwnProperty(key)) {
			     sortable.push([key, obj[key]]);
           sortable.sort(function(a, b) {
               // console.log(a[1].element.zindex , b[1].element.zindex);
			         return b[1].element.zindex - a[1].element.zindex;
		       });
        }
    }
	  return sortable;
  }

  componentDidMount() {
    this.props.display.registDataListener(this.props.stateName,this);
    if(this.props.readAlong !== undefined) {
      var readAlongs = this.props.readAlong.split("|");
      for (var r in readAlongs){
          this.props.display.registDataListener(readAlongs[r],this);
      }
    }
    if(this.props.display.state.gameStates[this.props.stateName]!==undefined) {
      this.onData(this.props.display.state.gameStates[this.props.stateName],this.props.stateName);
    }
  }

  render() {
    /*
    if(this.state.data === undefined || this.state.overlayConfig === undefined || this.state.overlayConfig.elements === undefined) {
      return (<div className={this.state.transition}/>);
    }
   */

   var sy = {position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%', opacity: 0,zIndex:(this.props.zindex)};
   if(this.state.data === undefined || this.state.overlayConfig === undefined || this.state.overlayConfig.elements === undefined){
     sy = {display:"none", position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%',zIndex:this.props.zindex};
   }

    var elements = this.state.overlayConfig.elements;
    var counter = 0;
    return (
        <div className={this.props.stateName} style={sy}>

         {this.sortProperties(elements).map(([key,element],i) => {
            counter++;
            var e = element.element;
            var k = e.elementType+"_"+e.dataSource+"_"+counter;
            if (!e.enable) {
              return ("");
            }

            if(e.displayCondition !== undefined && e.displayCondition !== '') {
              var res = eval('(function () {return '+ e.displayCondition+';})').call(this);
              if( !res ) {
                return (<div className={this.state.transition}/>);
              }
            }

            if(e.elementType === "dataText") {
              var txt = eval('(function () {return this.state.data!==undefined && this.state.data.'+e.dataSource+' !== undefined ? this.state.data.'+e.dataSource+':"";})').call(this);
              if(txt !== undefined &&  typeof txt === "object") {
                return (
                  <div key={k} style={{position : "absolute", overflow : "hidden", lineHeight:e.lineHeight, opacity: e.opacity, left :e.x+"px",top : e.y+"px",width :e.width+"px",height :e.height+"px",display: "flex",alignItems: e.valign,justifyContent: e.align,}}>
                  <span style={{color :e.fontColor, fontFamily : e.font, fontSize : e.fontSize + "px"}}><table>
                  	{txt.map((t) => {
                      var tabs = t.split("#TAB#");
                      if(tabs.length > 1) {
                      return (<tr>
                        {tabs.map((b)=>{
                          return (<td style={{paddingLeft: e.fontSize + "px"}}>{b}</td>);
                        })}
                        </tr>);
                      } else {
                        return (<span key={t}>{t}<br/></span>);
                      }
                    })}
                  </table></span>
                  </div>
                );
              } else {
                return (
                  <div key={k} style={{position : "absolute",overflow : "hidden", opacity: e.opacity,  left :e.x+"px",top : e.y+"px",width :e.width+"px",height :e.height+"px",display: "flex",alignItems: e.valign,justifyContent: e.align,}}>
                    <span style={{color :e.fontColor, fontFamily : e.font, fontSize : e.fontSize + "px"}}>{txt}</span>
                  </div>
                );
              }
            }

            if(e.elementType === "dataKeyText"){
              return (
                <div key={k} style={{position : "absolute",opacity: e.opacity, left :e.x+"px",top : e.y+"px",width :e.width+"px",height :e.height+"px",display: "flex",alignItems: e.valign,justifyContent: e.align,}}>
                <span style={{color :e.fontColor, fontFamily : e.font, fontSize : e.fontSize + "px"}}>
                  <DataText stateName={e.dataSource} display={this.props.display}/>
                </span>
                </div>
              );
            }

            if(e.elementType === "text"){
              return (
                <div key={k} style={{position : "absolute",lineHeight:e.lineHeight, opacity: e.opacity, left :e.x+"px",top : e.y+"px",width :e.width+"px",height :e.height+"px",display: "flex",alignItems: e.valign,justifyContent: e.align,}}>
                  <span style={{color :e.fontColor, fontFamily : e.font, fontSize : e.fontSize + "px"}}>{e.dataSource}</span>
                </div>
              );
            }

            if(e.elementType === "dataImage" && e.dataSource !== undefined && e.dataSource !== '') {
              var url = eval('(function () {return this.state.data!==undefined && this.state.data.'+e.dataSource+' !== undefined ? this.state.data.'+e.dataSource+':"images/empty.png";})').call(this);
              if(url.startsWith("http")){
                  return (
                      <div key={k} style={{ position : "absolute", opacity: e.opacity, left : e.x+"px", top :  e.y+"px", maxWidth : e.width+"px", maxHeight : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                        <img alt="" className="image-fluid" style={{maxWidth: e.width + "px", maxHeight :e.height+"px"}}
                        src={url} />
                      </div>
                  );
              } else {
                return (
                    <div key={k} style={{ position : "absolute", opacity: e.opacity, left : e.x+"px", top :  e.y+"px", width : e.width+"px", height : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                      <img alt="" className="image-fluid" style={{maxWidth: e.width + "px", maxHeight :e.height+"px"}}
                      src={_GPY.resource("upload/" + url)} />
                    </div>
                );
              }
            }

            if(e.elementType === "image" && e.imageSrc !== undefined && e.imageSrc !== '') {
              return (
                  <div key={k} style={{ position : "absolute", opacity: e.opacity, left : e.x+"px", top :  e.y+"px", width : e.width+"px", height : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                    <img alt="" className="image-fluid" style={{maxWidth: e.width + "px", maxHeight :e.height+"px"}}
                    src={_GPY.resource("upload/" + e.imageSrc )} />
                  </div>
              );
            }

            if(e.elementType === "colors" && e.dataSource !== undefined && e.dataSource !== '') {
              return (
                <div key={k} >
                <div style={{position : "absolute",opacity: e.opacity, left :e.x+"px",top : e.y+"px",width : e.width+"px",height : (e.height/2)+"px", display: "flex", alignItems: e.valign, justifyContent: e.align,
                  backgroundColor: eval('(function () {return this.state.data!==undefined && this.state.data.'+e.dataSource+' ? this.state.data.' + e.dataSource + '.split(":")[0]:"#000";})').call(this) }}/>
                <div style={{position : "absolute",opacity: e.opacity, left :e.x+"px",top : (e.y+(e.height/2))+"px",width :e.width+"px",height : (e.height/2)+"px", display:"flex",alignItems: e.valign,justifyContent: e.align,
                  backgroundColor: eval('(function () {return this.state.data!==undefined && this.state.data.'+e.dataSource+' ? this.state.data.' + e.dataSource + '.split(":")[1]:"#000";})').call(this) }}/>
                </div>
              );
            }

            if(e.elementType === "timerText" && e.dataSource !== undefined && e.dataSource !== '') {
              return (
                  <div key={k} style={{ position : "absolute",opacity: e.opacity, left : e.x+"px", top :  e.y+"px", width : e.width+"px", height : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                    <span style={{color :e.fontColor, fontFamily : e.font, fontSize : e.fontSize + "px"}}>
                      <TimerText overlay={this} overlayConf={e} stateName={e.dataSource} display={this.props.display}/>
                    </span>
                  </div>
              );
            }


            if(e.elementType === "AnalogClock" && e.dataSource !== undefined && e.dataSource !== '') {
              return (
                  <div key={k} style={{ position : "absolute",opacity: e.opacity, left : e.x+"px", top :  e.y+"px", width : e.width+"px", height : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                      <AnalogClock overlay={this} overlayConf={e} element={e} stateName={this.props.stateName} display={this.props.display}/>
                  </div>
              );
            }


            return (<span>unkown: {e.elementType}</span>);
          }
         )}
        </div>
    );
  }
}
export default Overlay;
